export default __webpack_public_path__ + "static/media/mail.75e3c4b0.svg";